import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import  Navbar from "./components/Navbar";
import Header from "./components/Header";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
  <>
  <Navbar/>
  <Header/>
  <About/>
  <Projects/>
  <Contact/>
  <Footer/>
  </>
  );
}

export default App;
